module.exports = __webpack_public_path__ + "media/images/print-bbadbe17d8090420fffd4398f025464a.jpg";